import axios from "axios";
import UserInfoInterface from "@/myProfileSection/types/UserInfoInterface";
import ProfileCardInterface from "@/myProfileSection/types/ProfileCardInterface";
import { ProfileRequest, PricesAndServicesRequest } from "@/myProfileSection/types/ProfileRequest";
import MetroItemResponse from "@/myProfileSection/types/MetroItemResponse";
import DistrictItemResponse from "@/myProfileSection/types/DistrictItemResponse";
import CreateProfileResponse from "@/myProfileSection/types/CreateProfileResponse";
import EditProfileInfo from "@/myProfileSection/types/EditProfileInfo";
import ProfilePhoto from "@/myProfileSection/types/ProfilePhoto";
import HairColorInterface from "@/myProfileSection/types/HairColorInterface";

export default {
    async changePassword(
        currentPassword: string,
        newPassword: string,
        confirmPassword: string,
    ): Promise<void> {
        await axios.post('/api/lk/change_password', {
            currentPassword,
            newPassword,
            confirmPassword,
        })
    },

    async changeProfileVisibility(id: number, active: boolean): Promise<void> {
        await axios.post('/api/lk/change_visibility', {
            id,
            active,
        })
    },

    async deleteProfile(id: number): Promise<void> {
        await axios.post('/api/lk/remove_profile', {
            id,
        })
    },

    async getUserInfo(): Promise<UserInfoInterface> {
        return (await axios.get('/api/lk/user_info')).data
    },

    async getProfiles(): Promise<ProfileCardInterface[]> {
        return (await axios.get('/api/lk/profiles_list')).data
    },

    async createProfile(data: ProfileRequest): Promise<CreateProfileResponse> {
        return (await axios.post('/api/lk/profile', data)).data
    },

    async editProfile(profileId: number, data: ProfileRequest): Promise<CreateProfileResponse> {
        return (await axios.put(`/api/lk/profile/${profileId}`, data)).data
    },

    async addPricesAndServices(profileId: number, data: PricesAndServicesRequest): Promise<CreateProfileResponse> {
        return (await axios.post(`/api/lk/profile/${profileId}/price`, data)).data
    },

    async addPhotos(profileId: number, photos: ProfilePhoto[]): Promise<CreateProfileResponse> {
        const formData = new FormData();
        photos.forEach((photo, index) => {
            formData.append(`photo[${index}][file]`, photo.file!);

            if (photo.is_main) {
                formData.append(`photo[${index}][is_main]`, 'true');
            }

            if (photo.is_background) {
                formData.append(`photo[${index}][is_preview]`, 'true');
            }
        });
        
        return (await axios.post(`/api/lk/profile/${profileId}/photos`, formData)).data
    },

    async deletePhotos(profileId: number, ids: number[]): Promise<CreateProfileResponse> {
        return (await axios.delete(`/api/lk/profile/${profileId}/photos`, {
            data: { photoIds: ids }
        })).data
    },

    async getMetroList(): Promise<MetroItemResponse[]> {
        return (await axios.get('/api/metro_list')).data
    },

    async getDistrictList(): Promise<DistrictItemResponse[]> {
        return (await axios.get('/api/district_list')).data
    },

    async changeAvatar(photo: File): Promise<void> {
        const formData = new FormData()
        formData.append('avatar', photo)
        await axios.post('/api/lk/change_user_avatar', formData)
    },

    async getEditProfileInfo(id: number): Promise<EditProfileInfo> {
        return (await axios.post('/api/lk/edit_profile/profile_info', {
            id,
        })).data
    },

    async uploadPhoto(idProfile: number, photo: File): Promise<ProfilePhoto> {
        const formData = new FormData()
        formData.append('photo', photo)
        formData.append('idProfile', String(idProfile))
        return (await axios.post('/api/lk/change_profile/upload_photo', formData)).data
    },

    async removePhoto(idProfile: number, idPhoto: number): Promise<void> {
        await axios.post('/api/lk/change_profile/remove_photo', {
            idProfile,
            idPhoto,
        })
    },

    async getHairColors(): Promise<HairColorInterface[]> {
        return (await axios.get('/api/hair_colors')).data
    },
}